<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const activeImports = computed(() => {
  return store.getters['dataImports/getActiveImports'];
});

const getPercentage = job => {
  return Math.max(
    0,
    Math.min(
      100,
      Math.round(
        (job.processed_records /
          Math.max(job.total_records || 1, job.processed_records || 1)) *
          100
      )
    )
  );
};
</script>

<template>
  <div class="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2">
    <transition-group
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform translate-y-4 opacity-0"
      enter-to-class="transform translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="transform translate-y-0 opacity-100"
      leave-to-class="transform translate-y-4 opacity-0"
    >
      <div
        v-for="job in activeImports"
        :key="job.id"
        class="relative w-80 overflow-hidden rounded-lg border border-slate-200 bg-white p-4 shadow-xl dark:border-slate-700 dark:bg-slate-800"
      >
        <div class="mb-2 flex items-center justify-between">
          <span
            class="text-xs font-semibold uppercase tracking-wider !text-slate-500 dark:!!text-slate-400"
          >
            {{
              $t('CONTACTS_PAGE.IMPORT_PROGRESS.TITLE') || 'Importing Contacts'
            }}
          </span>
          <span
            class="text-xs font-medium !text-slate-700 dark:!!text-slate-300"
          >
            <template v-if="job.status === 'processing'">
              {{ `${getPercentage(job)}%` }}
            </template>
            <template v-else-if="job.status === 'completed'">
              {{ $t('CONTACTS_PAGE.IMPORT_PROGRESS.COMPLETED') || 'Complete' }}
            </template>
            <template v-else-if="job.status === 'failed'">
              {{ $t('CONTACTS_PAGE.IMPORT_PROGRESS.FAILED') || 'Failed' }}
            </template>
          </span>
        </div>

        <div
          class="mb-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700"
        >
          <div
            class="h-1.5 rounded-full transition-all duration-300 ease-in-out"
            :class="{
              'bg-woot-500': job.status === 'processing',
              'bg-green-500': job.status === 'completed',
              'bg-red-500': job.status === 'failed',
            }"
            :style="{ width: `${getPercentage(job)}%` }"
          />
        </div>

        <p
          v-if="job.status === 'processing'"
          class="truncate text-xs !text-slate-500"
        >
          {{ job.processed_records }}
          {{ $t('CONTACTS_PAGE.IMPORT_PROGRESS.OF') || 'of' }}
          {{ job.total_records || '...' }}
          {{ $t('CONTACTS_PAGE.IMPORT_PROGRESS.RECORDS') || 'records' }}
        </p>
        <p
          v-else-if="job.status === 'failed'"
          class="truncate text-xs !text-red-500"
        >
          {{ job.error }}
        </p>
      </div>
    </transition-group>
  </div>
</template>
